import React from 'react'
import { Column } from 'primereact/column'
import { FilterMatchMode } from 'primereact/api'
import ProgrammeTypeFilterTemplate from '../Filters/ProgrammeTypeFilterTemplate'
import { createFieldChangedChecker } from '../utils/createFieldChangedChecker'

/**
 * Programme Type column component with icon type dropdown filter
 * Displays custom template (typically icons) and filters by iconId (1=Radio, 2=Film, 3=TV)
 * @param {string} title - Column header title
 * @param {string} mapsToField - Field name in data (iconId)
 * @param {boolean} filter - Enable filtering
 * @param {boolean} sortable - Enable sorting
 * @param {boolean} editable - Enable editing
 * @param {Function} isFieldChanged - Function to check if field changed
 * @param {Function} isFieldChangedOverride - Override for field change checker
 * @param {Object} validationErrors - Validation errors object
 * @param {Function} template - Custom display template (required - typically displays icons)
 * @param {Object} originalData - Original data for comparison
 * @param {Object} style - Column style
 */
const ProgrammeTypeColumn = ({ 
    title, 
    mapsToField, 
    filter, 
    sortable, 
    editable, 
    isFieldChanged, 
    isFieldChangedOverride, 
    validationErrors, 
    template, 
    originalData,
    style
}) => {

    const filterAttributes = filter ? {
        filter: true,
        showFilterMenu: true,
        filterElement: (options) => <ProgrammeTypeFilterTemplate options={options} />,
        filterMatchMode: FilterMatchMode.EQUALS,
        showFilterMatchModes: false
    } : {}

    const sortAttributes = {
        sortable,
        required: !!sortable,
        disabled: !sortable
    }

    // Create smart field changed checker
    const checkFieldChanged = createFieldChangedChecker({
        editable,
        isFieldChangedOverride,
        defaultIsFieldChanged: isFieldChanged,
        mapsToField,
        originalData
    })

    // Use the provided template (typically displays icons based on iconId)
    const bodyTemplate = template || ((rowData) => rowData[mapsToField])

    return (
        <Column
            {...sortAttributes}
            key={mapsToField}
            field={mapsToField}
            header={title}
            style={style}
            body={(rowData) => (
                <span className={`${checkFieldChanged(rowData) ? 'changed-field' : ''} ${rowData.isDeleted ? 'pending-deletion' : ''}`}>
                    {bodyTemplate(rowData)}
                </span>
            )}
            {...filterAttributes}
        />
    )
}

export default ProgrammeTypeColumn



